/**
 * Google Sheets 아이콘 SVG
 *
 * 크기 조절: className으로 w-*, h-* 클래스 사용
 * @example
 * ```tsx
 * <GoogleSheetsIcon className="w-8 h-8" />
 * <GoogleSheetsIcon className="w-12 h-12" />
 * ```
 */
export function GoogleSheetsIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      fill="none"
      className={className}
      aria-label="Google Sheets icon"
      role="img"
    >
      <title>Google Sheets</title>
      <g id="Google Sheets">
        <g id="Vector">
          <path
            d="M24.5312 30H7.46875C6.38134 30 5.5 29.1047 5.5 28V4C5.5 2.89533 6.38134 2 7.46875 2H19.9375L26.5 8.66667V28C26.5 29.1047 25.6187 30 24.5312 30Z"
            fill="#43A047"
          />
          <path d="M26.5 8.66667H19.9375V2L26.5 8.66667Z" fill="#C8E6C9" />
          <path d="M19.9375 8.66667L26.5 15.3334V8.66667H19.9375Z" fill="#2E7D32" />
          <path
            d="M10.0937 15.3333V24.6666H21.9062V15.3333H10.0937ZM11.4062 16.6666H14.0312V18H11.4062V16.6666ZM11.4062 19.3333H14.0312V20.6666H11.4062V19.3333ZM11.4062 22H14.0312V23.3333H11.4062V22ZM20.5937 23.3333H15.3437V22H20.5937V23.3333ZM20.5937 20.6666H15.3437V19.3333H20.5937V20.6666ZM20.5937 18H15.3437V16.6666H20.5937V18Z"
            fill="#E8F5E9"
          />
        </g>
      </g>
    </svg>
  );
}
